import axios from "axios";
let Base64 = require("js-base64").Base64;
// let http = 'http://192.168.1.114:31003/'
// let http = "http://110.191.179.139:31003/"; // 外网
// let http = "http://117.119.79.106:30001/"; // 北京地址
// let http = "http://117.119.79.106:30000/"; // 北京测试
let http = "/api/"; // 代理设置
// let https = "/timeline-service/"; // 代理设置--2
// let httpss = "/demo/"; // 代理设置--2

// 获得当前的问卷
export let getCurForm = function (id) {
    return axios.get(http + `survey-service/surveys/${id}`);
    // return axios.get(http + `sdc-service/form-schemas`);
};

// 获得当前的问卷
export let getCurFormConfig = function (id) {
    return axios.get(http + `survey-service/survey-configs/${id}`);
};

// 提交问卷
export let submitCurForm = function (data) {
    return axios.post(http + "survey-service/reports", data);
};

// 获取筛查项目
export let getCancerConfig = () => {
    // http://110.191.179.139:31003/survey-service/disease-item-config
    return axios.get(http + "survey-service/disease-item-config");
};

// 提交问题答案
export let submitQuestionnaire = (data) => {
    return axios({
        method: "POST",
        url: http + "survey-service2/early/saveQuestionResult",
        data: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
    });
};

// 保存风险分类
export let saveRiskKinds = (data) => {
    return axios({
        method: "POST",
        url: http + "survey-service2/early/saveQuestionResult",
        data: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
    });
};

// 保存筛查方案
export let saveScreeningPlan = (data) => {
    return axios({
        method: "POST",
        url: http + "survey-service2/early/saveScreenWayResult",
        data: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
    });
};

// 查询单癌种筛查方案
export let getSingleScreening = function (id) {
    return new Promise((resolve,reject) => {
        axios.get(http + `dict-service/dict/synCancerDictData`).then(res => {
            resolve(res)
        }).catch(err => {
            resolve(err)
        })
    })
    return axios.get(http + `dict-service/dict/synCancerDictData`);
};

// 查询绑定患者
export let queryPatient = (params) => {
    return axios({
        method: "POST",
        url: http + "survey-service/patient/query",
        data: JSON.stringify(params),
        headers: { "Content-Type": "application/json" },
    });
};

// 创建患者信息
export let createPatient = (params) => {
    return axios({
        method: "POST",
        url: http + "survey-service/patient/createHis",
        data: JSON.stringify(params),
        headers: { "Content-Type": "application/json" },
    });
};

// 发送验证码
export let getCode = (params) => {
    return axios({
        method: "POST",
        url: http + "survey-service/verification/getCode",
        data: JSON.stringify(params),
        headers: { "Content-Type": "application/json" },
    });
};


// 校验验证码
export let checkCode = (params) => {
    return axios({
        method: "POST",
        url: http + "survey-service/verification/checkCode",
        data: JSON.stringify(params),
        headers: { "Content-Type": "application/json" },
    });
};

// 校验验证码
// export let createLocal = (params) => {
//     return axios({
//         method: "POST",
//         url: http + "survey-service/patient/createLocal",
//         data: JSON.stringify(params),
//         headers: { "Content-Type": "application/json" },
//     });
// };
// 修改1
// 校验验证码
export let createLocal = (params, id) => {
    return axios({
        method: "put",
        url: http + `survey-service/result/${id}`,
        data: JSON.stringify(params),
        headers: { "Content-Type": "application/json" },
    });
};

// 获取openid
export let getOpenId = (codeId) => {
    return axios({
        method: 'get',
        url: http + `survey-service/wx/getUserInfo?code=${codeId}`,
        data: JSON.stringify(codeId),
        headers: { "Content-Type": "application/json" },
    })
}
//获取查看文件文件流
export let previewNew = (ftpSource,ftpPath) => {
 let ftpPaths=Base64.encode(ftpPath)
  return axios({
      method: 'get',
      url: http + `timeline-service/file/ftp/preview-new?ftpSource=${ftpSource}`,
      headers: { "ftpPath": ftpPaths },
      responseType: 'blob',
  })
}

// 获取微信配置
export let getWxConfig = (urlLink) => {
  console.log('urlLink', urlLink)
    return axios({
        method: 'post',
        url: http + `survey-service/wx/getSignature`,
        data: JSON.stringify(urlLink),
        headers: { "Content-Type": "application/json" },
    })
}
// 创建订单
export let createOrder = (codeId) => {
    return axios({
        method: 'post',
        url: http + `survey-service/wx/createOrder`,
        data: JSON.stringify(codeId),
        headers: { "Content-Type": "application/json" },
    })
}

// 通过openid去查询 关联患者
export let getPatientsWidthOpenId = (openId) => {
    return axios.get(http + `data-access-api-service/patient/info?openId=${openId}`)
}

// 通过patientid去查询 检验报告
export let getPatientLabReport = (patientId) => {
    return axios.get(http + `data-access-service/patient/inspectionReport?healthCardNo=${patientId}`)
}
// 通过patientid去查询 检验报告内容
export let getPatientLabReportInfo = (daId) => {
    return axios.get(http + `data-access-service/patient/inspectionReportData?daId=${daId}`)
}


// 企业微信-通过危急值id查询危急值表单
export let getWarnInfo = (warnId, account) => {
    return axios.get(http + `composer-service/warn/standingBook/info?warnId=${warnId}&account=${account}`)
}
// 企业微信-保存危急值处理结果
export let saveWarnInfoForm = (params) => {
    return axios.post(http + `composer-service/warn/handle/save`, params)
}

// 企业微信-查询危急值台账所有记录
export let getStandingBookList = (params) => {
    return axios.get(http + `composer-service/warn/standingBook/list`, params)
}
// 企业微信-根据危急值编码查询处理记录
export let getWarnHandleList = (params) => {
    return axios.get(http + `composer-service/warn/handle/list?warnId=${params.warnId}`)
}
// 企业微信-根据危急值编码查询发送、接收记录
export let getWarnSendList = (params) => {
    return axios.get(http + `composer-service/warn/send/list?warnId=${params.warnId}`)
}

export let getPatientCheckReport = (patientId) => {
  return axios.get(http + `data-access-api-service/patient/queryRisUReport?healthCardNo=${patientId}`)
}
export let getPatientsReportInformation = (params) => {
    return axios.get(http + `data-access-api-service/patient/allReport?${params}`)
}
export let getPatientsData = (params) => {
    return axios.get(http + `data-access-api-service/patient/patientBase?healthCardNo=${params}`)
}
export let getAuthentication = (params) => {
    return axios.get(http + `data-access-api-service/patient/miniProgram/authentication?code=${params.code}&patientId=${params.patientId}`)
}
// 分享-加密链接
export let setEncryptedLink = (data) => {
  return axios({
      method: 'post',
      url: http + `wechat-service/dicom/encryptionurl`,
      // url: https + `dicom/encryptionurl`,
      data,
      headers: { "Content-Type": "application/json" },
  })
}
// 分享-解密链接
export let getdecryptionLink = (params) => {
  return axios.get(http + `wechat-service/dicom/deciphering?encryption=${params.encryption}&password=${params.password}&onlyShare=${params.onlyShare}`)
  // return axios.get(https + `dicom/decipheringurl?encryption=${params.encryption}&password=${params.password}`)
}
// 时间轴复制影像链接
// time-0 失效
export let timelineCopyImageLinks = (data) => {
  return axios({
      method: 'post',
      url: http + `wechat-service/dicom/checktimelineImage`,
      // url: https + `dicom/timelineGetImage`,
      data,
      headers: { "Content-Type": "application/json" },
  })
}
//用药数据
export let getMedicationData = (params) => {
  return axios.get(http + `data-access-api-service/patient/patientDrug?healthCardNo=${params.healthCardNo}&keyword=${params.keyword}`)
  // return axios.get(httpss + `patient/patientDrug?healthCardNo=${params.healthCardNo}&keyword=${params.keyword}`)
}


// 检查支付是否成功
export let getWxSing = function (url) {
  return axios({
    method: 'post',
    url: http + `wechat-service/weChat/getSign`,
    data: {
      url:JSON.stringify(url)
    },
  });
};

export let getPDF = function (params) {
  return axios({
    method: 'post',
    url: http + `data-access-api-service/patient/addWaterMark`,
    responseType: 'blob',
    data: {
      url:params.url,
      daId:params.daId,
    },
  });
};

// 获取长图链接
export let getUrlApi = (daId) => {
    return axios.get(http + `checkup-report-service/getUrl?daId=${daId}`)
}



// WEBPACK FOOTER //
// ./src/apis/apis.js